import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql, Script } from 'gatsby'
import PropTypes from 'prop-types'

import Nav from './nav'
import Footer from './footer'

export default function Layout({ isHomePage, children }) {
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      wpPartnerSeite {
        title
        partnerseite {
          disableProducts {
            ... on WpRwProduct {
              id
            }
          }
          kontakt {
            email
            tel
            telLink
            tel2
            tel2Link
          }
          legal {
            firmenbezeichnung
          }
          identity {
            invertDefaultMenu
            invertiertesLogoOptional {
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(
                    height: 96
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              altText
            }
            navigationDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    height: 48
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              altText
            }
            primaryColour
            heroImageBlendMode
            favicon {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  const { title, partnerseite } = data.wpPartnerSeite
  const primaryColour =
    data.wpPartnerSeite.partnerseite.identity.primaryColour ?? '#000acb'
  const heroBlendMode =
    data.wpPartnerSeite.partnerseite.identity.heroImageBlendMode ?? 'overlay'

  const favicon = {
    data: data.wpPartnerSeite?.partnerseite?.identity?.favicon?.localFile
      ?.publicURL,
  }

  return (
    <>
      <Script src="https://cdn.rtr-io.com/widgets.js" type="module" />
      <Script>{`
window.RTR_ACCESS_TOKEN = 'W45827c69d586e256bd7427fd96d357ca';
window.RTR_LOCALE = 'de-DE';
      `}</Script>
      <div className="global-wrapper" data-is-root-path={isHomePage}>
        <Helmet>
          <style type="text/css">{`
            :root {
              --primary-colour: ${primaryColour};
              --hero-blend-mode: ${heroBlendMode};
            }
          `}</style>
          {favicon.data && (
            <link rel="icon" type="image/png" href={favicon.data} />
          )}
        </Helmet>
        <Nav />

        <main className="min-h-[70vh] ">{children}</main>

        <Footer title={title} partnerseite={partnerseite} />
      </div>
      <rtr-checkout></rtr-checkout>
    </>
  )
}

Layout.propTypes = {
  isHomePage: PropTypes.bool,
  children: PropTypes.array,
}
